import styled from 'styled-components';
import { Text16Regular } from '../../utils/Text/Text.styles';

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4rem;
  margin-top: 5rem;
  padding: 0 2rem;
`;

export const Text = styled(Text16Regular)`
  text-align: center;
  width: 35rem;
`;
